import { connectRouter } from 'connected-react-router'
import type { History } from 'history'
import { type Action, combineReducers } from 'redux'
import auth from 'reduxStore/auth/reducer'
import projects from 'reduxStore/projects/reducer'
import edit from './edit'
import materials from './materials/reducer'
import quote from './quote'
import tools from './tools'

const createAppReducers = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    edit,
    projects,
    tools,
    quote,
    materials,
  })

const createRootReducer = (history: History) => (state: any, action: Action) => {
  if (action.type === 'auth/AUTH_LOG_OUT') {
    return createAppReducers(history)(undefined, action)
  }

  return createAppReducers(history)(state, action)
}

export default createRootReducer
